export default {
  // Index
  notifications: {
    english: "Notifications",
    spanish: "Notificaciones",
  },
  noNotifications: {
    english: "No notifications",
    spanish: "No hay notificaciones",
  },
};
